/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React from 'react';
import { Toast } from 'react-bootstrap';
import {MdVerified} from 'react-icons/md'
import {IoMdClose} from 'react-icons/io'

interface CustomToastProps {
  show: boolean;
  onClose: () => void;
  delay: number;
  message: string;
  toastType: string;
  toastPosition?: string;
}

const CustomToast: React.FC<CustomToastProps> = ({
  show,
  onClose,
  delay,
  message,
  toastType,
  toastPosition,
}) => {
  const toastClassName = `toasterClass 
    ${toastType === 'error' ? 'error' : ''} 
    ${toastPosition === 'topLeft' ? 'topLeft' : ''} 
  `;

  return (
    <Toast className={toastClassName} onClose={onClose} show={show} delay={delay * 8} autohide>
      <div className="d-flex justify-content-around text-center pt-1">
        <div>
          <MdVerified className='m-2' fontSize={20} />
        </div>
        <p className='toasterText m-2'>{message}</p>
        <div>
          <IoMdClose onClick={onClose} className='m-2' fontSize={25} />
        </div>
      </div>
    </Toast>
  );
};

export default CustomToast;
